// SECTION: scroll-light-text.liquid
// Target class names: 
// textcontainer: 'scroll-light-text__inner-wrapper,
// textEl: '.scroll-light-text__text'. 
document.addEventListener("DOMContentLoaded", function () {
  if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined" || typeof SplitText === "undefined") {
    console.warn("GSAP or required plugins (ScrollTrigger, SplitText) not found.");
    return;
  }

  const triggerEl = document.querySelector(".scroll-light-text__inner-wrapper");
  const textEl = document.querySelector(".scroll-light-text__text");
  
  document.fonts.ready.then(() => {
    gsap.registerPlugin(ScrollTrigger, SplitText);
    const splitText = new SplitText(textEl, {
      type: "words,chars",
      charsClass: "line",
      wordsClass: "word"
    }); 

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: triggerEl,
        scrub: 1,
        start: "top 60%",
        end: "bottom 60%",
      }
    });

    tl.to(".line", {
      "--highlight-offset": "100%",
      stagger: 0.5
    });
  });
});
